/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-26 16:20:35
 */
import { constantRouter, asyncRouter, resetRouter } from '../router'
// 根据role判断路由
function hasPeimisson (role, route) {
  if (route.meta && route.meta.role) {
    return route.meta.role.indexOf(role) >= 0
  } else {
    return true
  }
}
// 过滤路由
function filterAsyncRoutes (routes, role) {
  const res = []
  routes.forEach(ele => {
    const tmp = { ...ele }
    if (hasPeimisson(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, role)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: null,
  addRoutes: null
}

const mutations = {
  SET_ROUTES (state, routes) {
    state.routes = routes
    state.addRoutes = constantRouter.concat(routes)
  }
}

const actions = {
  getAsyncRoutes ({ commit }, role) {
    return new Promise((resolve, reject) => {
      try {
        let accessRouter = filterAsyncRoutes(asyncRouter, role)
        commit('SET_ROUTES', accessRouter)
        resolve(accessRouter)
      } catch (error) {
        reject(error)
      }
    })
  },
  resetRoutes ({ commit }) {
    return new Promise(resolve => {
      commit('SET_ROUTES', [])
      resetRouter()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/permission.js